import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAiAssistantAccess } from '@/hooks/use-ai-assistant-access';
import { editorPathFromStudio } from '@/lib/ai-assistant/aiStudioPaths';

// AI Studio is for users with the `ai_assistant` feature; everyone else lands
// on the full editor of the same clip. Nothing is decided while the account
// loads, so a granted user never bounces.
export function AiStudioRoute({ children }: { children: ReactNode }) {
  const { ready, enabled } = useAiAssistantAccess();
  const location = useLocation();
  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="ai-studio-gate">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (!enabled) {
    return <Navigate to={editorPathFromStudio(location.pathname + location.search)} replace />;
  }
  return <>{children}</>;
}
